var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7.5 7.5 15 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.687 14.995q0-1.567.85-2.871l7.363 7.33q-1.337.866-2.9.866-1.084 0-2.065-.424-.982-.423-1.695-1.134t-1.133-1.698-.42-2.069m9.756 2.91-7.373-7.339Q13.39 9.68 15 9.68q1.445 0 2.666.711 1.22.71 1.934 1.937.712 1.227.712 2.667 0 1.577-.869 2.91M7.5 14.996q0 1.528.596 2.92.595 1.392 1.596 2.395 1.001 1.002 2.393 1.596T15 22.5t2.915-.594 2.393-1.596 1.596-2.395.596-2.92-.596-2.915-1.596-2.39q-1.001-1.002-2.393-1.596T15 7.5t-2.915.594T9.692 9.69t-1.596 2.39-.596 2.915"
})));
export default SvgBan;